export default {"src":"/_next/static/media/button-plus.aecb2429.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};